import {
  treatsItem,
  treatsItems,
} from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import ActionsAPI, {
  deleteDocument,
} from '@/services/api/internal/actions.api';
import TechniciansService from '@/services/services/technicians.service';
import ActionPlansService from '@/services/services/actionplans.service';
import ActionTemplate from '@/business/mailto/templates/action.template';

const datetimeFieldNames = [
  'creation_datetime',
  'start_datetime',
  'deadline_datetime',
  'current_action_plan_status_datetime',
  'current_action_status_datetime',
];

const ActionsService = new BaseService({
  api: ActionsAPI,
  treatListResponse: treatsItems({
    booleanFieldNames: ['top_p1'],
    datetimeFieldNames,
  }),
  treatCurrentResponse: treatsItem({
    booleanFieldNames: ['top_p1'],
    datetimeFieldNames,
  }),
  treatCreateResponse: treatsItem({
    datetimeFieldNames,
  }),
});

export function deleteDocumentInAction(actionId, uid) {
  const body = { uid };
  return deleteDocument(actionId, body);
}

export function hideImageLinks(desc) {
  return desc
    .split('~~')
    .map((text) => (text.startsWith('img-uid') ? '[img]' : text))
    .reduce((acc, text) => acc + text, '');
}

ActionsService.openOutlook = async (builtItem, isEditing, errorHandler) => {
  const technicians = await TechniciansService.findTechByIdx(
    builtItem.persons_in_charge.map((el) => String(el.staff_id))
  );
  const actionplan = await ActionPlansService.getCurrent(
    builtItem.action_plan_id
  );
  const buildItem = {
    staffsInCharge: technicians,
    item: { ...builtItem, description: hideImageLinks(builtItem.description) },
    diagnostic: actionplan.description,
    isEditing,
  };
  window.location.href = new ActionTemplate(buildItem).mailto(errorHandler);
};
export default ActionsService;
